import styled from 'styled-components';
import React from 'react';
import { Radio, RadioGroup } from '@mui/material';
function RadioComponent(props: IRadioGroup) {
    return (
        <>
            <RadioGroup row value={props.value}>
                {props.list?.map((item, index) => (
                    <RadioLabelTag key={index}>
                        <Radio disabled={props.disabled ? true : false} value={item.value} onChange={props.onChange} />
                        {item.name}
                    </RadioLabelTag>
                ))}
            </RadioGroup>
        </>
    );
}

export default React.memo(RadioComponent);

export const RadioGroupTag = styled.div<IRadioGroup>`
    display: inline-flex;
    padding: 10px;
`;

export const RadioLabelTag = styled.label`
    display: inline-flex;
    align-items: center;
    font-size: 14px;
    cursor: pointer;

    padding-right: 20px;
    /* &:not(:last-child) {
    padding-right: 20px;
  } */

    & > input {
        cursor: pointer;
    }
`;

export interface IRadioGroup {
    onChange?: any;
    /**
     * 이름
     */
    name: string;
    /**
     * 너비
     */
    defaultSize?: 'small' | 'medium' | 'large' | 'full';
    /**
     * 데이터
     */
    list: { name: string; value: string }[];
    /**
     * display Block 여부 (기본 inline)
     */
    block?: Boolean;

    /**
     * 기본 선택 값
     */
    value?: string;

    /**
     * 기본 선택 값
     */
    defaultValue?: string;

    /**
     * 선택불가처리
     */
    disabled?: boolean;
}
